import { useStoreDollHouseMap } from "../../store";
import { useEffect, useState } from "react";
import {
  animationStart,
  animationEnd,
  showPopupWithContent,
  hidePopup,
} from "../../components/customEvents.js";
import { shallow } from "zustand/shallow";
import { DOLBY } from "../../scripts/core/constants";

export default function ParkMgmHotspots() {
  const [destconventionariaActive, setdestconventionariaActive] = useState("");
  const [destdolbyliveActive, setdestdolbyliveActive] = useState("");
  const [sourceconventionaariaActive, setsourceconventionaariaActive] =
    useState("");
  const [sourcedolbyliveActive, setsourcedolbyliveActive] = useState("");
  const [restaurentActive, setrestaurentActive] = useState("");
  const [sidrbarSelected, setSidebarSelected] = useState("");

  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      sourcePoidSelected: state.sourcePoidSelected,
      destinationPoidSelected: state.destinationPoidSelected,
      ParkMgmHighlightPoiStore: state.ParkMgmHighlightPoiStore,
      resetParkMgmHighlightPOI: state.resetParkMgmHighlightPOI,
      currentSidebarMenuSelected: state.currentSidebarMenuSelected,
    }),
    shallow
  );

  /*
   *PARK MGM EXIST Route POI HIGHLIGHTING [start]
   */
  useEffect(() => {
    if (dollhouseStore.sourcePoidSelected === "") {
      setsourceconventionaariaActive("");
      setsourcedolbyliveActive("");
    }

    if (dollhouseStore.sourcePoidSelected === "park_mgm_convention_area") {
      setsourceconventionaariaActive("active-poi-selection");
    }
    if (dollhouseStore.sourcePoidSelected === "park_mgm_dolby_live") {
      setsourcedolbyliveActive("active-poi-selection");
    }
  }, [dollhouseStore.sourcePoidSelected]);

  useEffect(() => {
    if (dollhouseStore.destinationPoidSelected === "") {
      setdestconventionariaActive("");
      setdestdolbyliveActive("");
    }

    if (dollhouseStore.destinationPoidSelected === "park_mgm_convention_area") {
      setdestconventionariaActive("active-poi-selection");
    }
    if (dollhouseStore.destinationPoidSelected === "park_mgm_dolby_live") {
      setdestdolbyliveActive("active-poi-selection");
    }
  }, [dollhouseStore.destinationPoidSelected]);
  /*
   *PARK MGM EXIST Route POI HIGHLIGHTING [end]
   */

  /*
   *PARK MGM NOT EXIST Route POI HIGHLIGHTING [start]
   */
  useEffect(() => {
    document.querySelectorAll(".poi-hover").forEach((val) => {
      val.classList.remove("active-poi");
    });
    setrestaurentActive("");

    console.log("called");

    if (dollhouseStore.ParkMgmHighlightPoiStore === "park_mgm_restaurent") {
      setrestaurentActive("active-poi");
    } else {
      if (document.getElementById(dollhouseStore.ParkMgmHighlightPoiStore)) {
        document
          .getElementById(dollhouseStore.ParkMgmHighlightPoiStore)
          .classList.add("active-poi");
      }
    }
  }, [dollhouseStore.ParkMgmHighlightPoiStore]);
  /*
   *PARK MGM NOT EXIST Route POI HIGHLIGHTING [end]
   */

  useEffect(() => {
    setSidebarSelected("");

    if (dollhouseStore.currentSidebarMenuSelected === DOLBY) {
      // console.log(
      //   "currentSidebarMenuSelected",
      //   dollhouseStore.currentSidebarMenuSelected
      // );

      setSidebarSelected("active-poi-selection");
    }
  }, [dollhouseStore.currentSidebarMenuSelected]);

  return (
    <>
      <g
        className={`poi-hover ${sidrbarSelected} ${destdolbyliveActive} ${sourcedolbyliveActive}`}
        id="park_mgm_dolby_live"
        fill="rgba(255,255,255,0.02)"
        onTouchStart={(e) => {
          showPopupWithContent(e, "park_mgm_dolby_live");
        }}
        onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("park_mgm_dolby_live");
          showPopupWithContent(e, "park_mgm_dolby_live");
        }}
        onTouchEnd={(e) => {
          showPopupWithContent(e, "park_mgm_dolby_live");
        }}
        // onMouseLeave={(e) => {

        //   console.log("hide")
        //   animationEnd("park_mgm_dolby_live");
        //   hidePopup("park_mgm_dolby_live");
        //   dollhouseStore.resetParkMgmHighlightPOI("");
        // }}
        data-name="Dolby Live"
        transform="translate(609.435 2405.8)"
      >
        <path
          id="dilby-live"
          d="M-8026.812-10380.45l148.414,52.328,28.332,48.935v19.688l21.945,37.751,14.942,8.186,30.43,51.607-15.632,104.446,113.733,1.089-2.027,64.446h-38.153v7.768l-119.669-1.57-21.6-4.4-21.6-6.706-19.453-8.192-21.267-10.6-19.358-12-21.849-15.435-16.657-13.336-17.049-15.895-5.681-6.1,12.748-14.119-10.4-12.569-7.821-10.31-11.43-18.21-11.055-18.821-10.157-23.565-7.919-22.187-3.925-15.065-2.455-11.892-1.3-9.067v-9.2l5.235-3.576-.4-17.083.907-22.307,3.791-24.573,6.012-26.428,5.938-15.859,8.3-17.862Z"
          transform="translate(8062.733 10380.45)"
        />
      </g>

      <g
        id="Park_MGM"
        data-name="Park MGM"
        transform="translate(587.558 1743.795)"
      >
        <path
          className="poi-hover"
          id="park_mgm_entry_point"
          d="M-6173.665-10947.074l5.258,2.619,5.851.291,6.242-1.619,7.395-4.914,5.583,3.623,3.933,2.418,4.347,1.258,3.732.283h4.25l4.923-1.049,1.753,2.641,1.418,1.818,1.7,1.461,1.977,1.2,2.038,1.236,2.156,1.068,2.477,1.012,2.558.686,1.672.412h7.793l.868,2.2.881,1.867,1.1,1.795,1.489,1.814,1.688,1.707,1.6,1.525,1.907,1.27,1.958,1.127,2.211,1.346,2.336.674,2.212.225h2.583l.345,2.492.6,2.506.99,2.654,1.308,2.529,1.254,2.016,1.912,2.438,2.193,2.063,1.943,1.664,2.4,1.293,2.578.977,1.768.547.25,5.576.513,3.164,1.147,2.883,1.4,2.816,2.369,3.377,3.259,3.352,2.489,1.719,2.927,1.615-1.412,2.523-.919,2.541-.6,1.947-.431,2.186-.17,2.5v4.107l.342,2.488.854,2.018.919,1.7,1.412,1.217,2.605,1.885-17.184,22.266-1.67-1.836-1.618-.982-1.2-.607-2.521-.3h-4.369l-2.995.912-3.2,1.617-1.916.936-2.258,1.486-2.828,2.193-2.5-2.193-1.874-1.486-2.114-1.57-1.42-.982-1.844-.607-2.313-.7-2.918-.48-3.473-.355h-2.937l-3.374.355-2.384.879-1.247-1.824-1.594-1.98-1.678-1.82-1.837-1.455-2.649-1.783-3.721-1.707-4.03-.617h-8.781l-.643-2.65-1.477-3.088-1.627-2.553-1.866-1.762-1.761-1.621-1.532-.873-1.567-.855-1.518-.713-2.446-.934-2.627-.312h-3.356l-.671-4.375-1.125-4.076-1.8-3.2-1.791-2.668-2.066-2.105-2.436-2.129-2.692-1.311-2.079-.953-2.379-.818v-2.873l-.6-5.146-.869-3.277-1.843-3.418-1.6-2.115-1.483-1.6-1.913-1.91-2.036-1.588-2.151-1.324-1.91-1.025.692-1.479.9-2.26,1-2.553.667-3.187v-4.057l-.667-4.369-.688-2.531-1.518-2.2-3.349-2.385Z"
          transform="translate(7329.738 11272.412)"
          fill="rgba(255,255,255,0.03)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "park_mgm_entry_point");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("park_mgm_entry_point");
            showPopupWithContent(e, "park_mgm_entry_point");
          }}
          onMouseLeave={(e) => {
            animationEnd("park_mgm_entry_point");
            hidePopup("park_mgm_entry_point");
            dollhouseStore.resetParkMgmHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("park_mgm_entry_point");
            dollhouseStore.resetParkMgmHighlightPOI("");
          }}
        />

        <path
          className="poi-hover"
          id="park_mgm_lobby"
          d="M-7133.432-11163.308l-24.724,9.306h-42.579v.861h-8.639v-4.15h-8.324v-23.021h8.324v-3.734h-5.547v-61.633h-33.7v-6.013h-8.893v27.619l-113.982-.083.055-93.183,116.716-.9v5.43h23.3v16.416h73.27v-111.463h24.724v164.712h-5.253v3.955h11.9v22.492h-11.9v4.431h5.253Z"
          transform="translate(7761.542 11456.765)"
          fill="rgba(255,255,255,0.03)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "park_mgm_lobby");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("park_mgm_lobby");
            showPopupWithContent(e, "park_mgm_lobby");
          }}
          onMouseLeave={(e) => {
            animationEnd("park_mgm_lobby");
            hidePopup("park_mgm_lobby");
            dollhouseStore.resetParkMgmHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("park_mgm_lobby");
            dollhouseStore.resetParkMgmHighlightPOI("");
          }}
        />

        <path
          className={`poi-hover`}
          id="park_mgm_convention_area"
          d="M-6885.664-10815.552l-26.736-15.469-29.145,48.3,10.155,6.825-30.743,50.418-64.545-38.009,30.18-50.88-30.18-19.149,13.609-22.4,3.377,1.716,13.194-22.208-3.708-2.227,19.986-32.352,30.75,18.222,28.368-46.888,57.536,33.153,6.67-11.4,5.014,2.727,14.619-23.288-5.931-3.272,41.646-67.854,234,139.773-46.808,77.471,9.346,5.684-15.344,26.391-10.736-5.81-40.033,71.285-16.465,26.763-134.469-76.21-78.215-45.011Z"
          transform="translate(7666.813 11296.157)"
          fill="rgba(255,255,255,0.07)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "park_mgm_convention_area");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("park_mgm_convention_area");
            showPopupWithContent(e, "park_mgm_convention_area");
          }}
          onMouseLeave={(e) => {
            animationEnd("park_mgm_convention_area");
            hidePopup("park_mgm_convention_area");
            dollhouseStore.resetParkMgmHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("park_mgm_convention_area");
            dollhouseStore.resetParkMgmHighlightPOI("");
          }}
        />

        <path
          className="poi-hover"
          id="park_mgm_pool"
          d="M-6742.815-11249.538l-65.226,109.344-23.7-14.15-19.812-35.565.5-138.235h12.309v-55.77l39.285-21.1,7.494,13.349,69.174,0-24.747-44.806,36.836-22.374,29.277,53.228,12.114,22.152,5.911,9.113,10.961,10.858,17.1,6.5,274,.615,18.437.543,12.184,1.044,4.507.333,11.371,2.7,8.157,4.178,3.949,3.239,5.31,4.554,3.458,3.7,5.06,6.087,5.164,7.2,3.558,6.338,2.514,5.356,2.1,6.343,1.879,8.961,1.348,9.786v68.24l-.226,4-1.374,4.266-2.469,3.953-2.889,1.6-6.287,1.6-2.937.2-130.149-.182-39.65,59.046-24.525-16.008-5.676,8.768-14.764-8.768-22.488,37.17Z"
          transform="translate(7596.191 11477.326)"
          fill="rgba(255,255,255,0.06)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "park_mgm_pool");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("park_mgm_pool");
            showPopupWithContent(e, "park_mgm_pool");
          }}
          onMouseLeave={(e) => {
            animationEnd("park_mgm_pool");
            hidePopup("park_mgm_pool");
            dollhouseStore.resetParkMgmHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("park_mgm_pool");
            dollhouseStore.resetParkMgmHighlightPOI("");
          }}
        />

        <path
          className="poi-hover"
          id="park_mgm_elevators"
          d="M-7233.752-10903.556l67.272,8.491,22.8,36.373-34.756,24.144-33.444-18.16-26.645,9.642-26.64-17.5Z"
          transform="translate(7762.986 11253.402)"
          fill="rgba(255,255,255,0.06)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "park_mgm_elevators");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("park_mgm_elevators");
            showPopupWithContent(e, "park_mgm_elevators");
          }}
          onMouseLeave={(e) => {
            animationEnd("park_mgm_elevators");
            hidePopup("park_mgm_elevators");
            dollhouseStore.resetParkMgmHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("park_mgm_elevators");
            dollhouseStore.resetParkMgmHighlightPOI("");
          }}
        />

        <g
          className="poi-hover"
          id="park_mgm_entrance_point_to_aria"
          transform="translate(1353.648 436.706)"
          fill="rgba(255,255,255,0)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "park_mgm_entrance_point_to_aria");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("park_mgm_entrance_point_to_aria");
            showPopupWithContent(e, "park_mgm_entrance_point_to_aria");
          }}
          onMouseLeave={(e) => {
            animationEnd("park_mgm_entrance_point_to_aria");
            hidePopup("park_mgm_entrance_point_to_aria");
            dollhouseStore.resetParkMgmHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("park_mgm_entrance_point_to_aria");
            dollhouseStore.resetParkMgmHighlightPOI("");
          }}
        >
          <path d="M0,0H67.71L52.767,33.013H0Z" stroke="none" />
          <path d="M 4.999996185302734 5.000001907348633 L 4.999996185302734 28.0132007598877 L 49.54203033447266 28.0132007598877 L 59.9585075378418 5.000001907348633 L 4.999996185302734 5.000001907348633 M -7.62939453125e-06 0 L 67.70999908447266 0 L 52.76720809936523 33.01320266723633 L -7.62939453125e-06 33.01320266723633 L -7.62939453125e-06 0 Z" />
        </g>

        <g
          id="park_mgm_restaurent_2"
          transform="translate(199.839 171.287)"
          className={`poi-hover ${restaurentActive}`}
          onTouchStart={(e) => {
            showPopupWithContent(e, "park_mgm_restaurent_2");
            setrestaurentActive("active-poi");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("park_mgm_restaurent_2");
            showPopupWithContent(e, "park_mgm_restaurent_2");
            setrestaurentActive("active-poi");
          }}
          onMouseLeave={(e) => {
            animationEnd("park_mgm_restaurent_2");
            hidePopup("park_mgm_restaurent_2");
            setrestaurentActive("");
            dollhouseStore.resetParkMgmHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("park_mgm_restaurent_2");
            setrestaurentActive("");
            dollhouseStore.resetParkMgmHighlightPOI("");
          }}
        >
          <path
            id="park_mgm_restaurent_12"
            data-name="parkmgm-restaurant"
            d="M-7042.216-11195.024h59.845l6.968-7.755h47.536l-.534,116.718h-113.171v-45.028h8.559v-28.029h-9.083Z"
            transform="translate(7473.24 11202.779)"
            fill="rgba(255,255,255,0.02)"
          />

          <path
            id="park_mgm_restaurent_22"
            data-name="Path 2041"
            d="M-7188.006-10376.122h72.371v179.915h38.475v136.2h-71.447v-136.2h-39.883v-29.368h8.3v-26.231h-8.3v-124.315Z"
            transform="translate(7532.226 10869.425)"
            fill="rgba(255,255,255,0.02)"
          />

          <path
            id="park_mgm_restaurent_32"
            data-name="Path 2042"
            d="M-7070.629-10689.43l14.87-25.158,30.042,19.39-42.034,70.529-30.345-18.1,13.718-23.244,7.14,4.111,14.518-22.8Z"
            transform="translate(7495.774 11005.912)"
            fill="rgba(255,255,255,0.02)"
          />

          <path
            id="park_mgm_restaurent_42"
            data-name="Path 2043"
            d="M-7325.859-9593.438h15.456v285.325L-7316-9300.9h-177.016l-25.229-2.443-11.009-2.764,1.674-9.909-28.363-5.045-1.925,7.63-34.531-12.622-37.743-20.683-19.979-14.107-16.813-13.559-35.388-35.12-9.64-10.644-6.608-8.3-8.015-9.778-4.059-5.806-10.014-14.675-9.753-15.278-7.768-17.885,21.744-7.714-9.371-36.616h-18.708V-9596.9h193.326v5.8h3.047v24.109h-3.047v10.045l4.909,13.253,3.583-2.143,32.147,34.5-1.95,2.119,8.422,4.715,11.075,3.1,11.891,1.589,12.25-.968,8.263-1.528,8.871-2.2,9.193-3.479,4.838-3.355-4.838-6.145,4.838-2.789,13.162-13.35.992-2.239,4.664,5.659,7.3-12,58.759,24.72,12.825,22.271,33.379-16.126v-82.1Z"
            transform="translate(7764.509 10555.197)"
            fill="rgba(255,255,255,0.02)"
          />
        </g>
      </g>
    </>
  );
}
